import { createReducer, on } from '@ngrx/store';
import * as PredictionActions from '../actions/prediction.actions';

export interface State {
  predictions: any[]; 
  userHistoryPredictions?: any[];
  selectedPrediction: any[],
  errorMessage: string | null;
  createSuccess?:boolean | null;
  isLaoding: boolean;
}
export const initialState: State = {
  predictions: [],
  userHistoryPredictions: [],
  selectedPrediction : [],
  errorMessage: null,
  isLaoding: false
};

export const predictionReducer = createReducer(
  initialState,

  on(PredictionActions.loadUserPredictions, (state) => ({
    ...state,
    isLaoding: true,
    errorMessage: null
  })),

  on(PredictionActions.loadUserPredictionsSuccess, (state, { predictions }) => ({
    ...state,
    predictions: predictions,
    isLaoding: false,
    errorMessage: null
  })),

  on(PredictionActions.loadUserPredictionsFailure, (state, { error }) => ({
    ...state,
    isLaoding: false,
    errorMessage: error
  })),
  on(PredictionActions.loadUserHistoryPredictions, (state) => ({
    ...state,
    isLaoding: true,
    errorMessage: null
  })),
  on(PredictionActions.loadUserHistoryPredictionsSuccess, (state, { predictions }) => ({
    ...state,
    userHistoryPredictions: predictions,
    isLaoding: false,
    errorMessage: null
  })),
  on(PredictionActions.loadUserHistoryPredictionsFailure, (state, { error }) => ({
    ...state,
    isLaoding: false,
    errorMessage: error
  })),

  on(PredictionActions.loadPredictionDetails, (state) => ({
    ...state,
    isLaoding: true,
    errorMessage: null
  })),
  on(PredictionActions.loadPredictionDetailsSuccess, (state, { prediction }) => ({
    ...state,
    selectedPrediction: prediction,
    isLaoding: false,
    errorMessage: null
  })),
  on(PredictionActions.loadPredictionDetailsFailure, (state, { error }) => ({
    ...state,
    isLaoding: false,
    errorMessage: error
  })),

  on(PredictionActions.createPredictionSuccess, (state) => ({
    ...state,
    createSuccess: true,
    isLaoding: false,
  }))
  
);